const ROOT_API = process.env.VUE_APP_ROOT_API;
const PHOTO_GET_PATH_LIST = ROOT_API + 'load_file/photo_get_path_list.php';
const PHOTO_GET_IMAGE = ROOT_API + 'load_file/photo_get_image.php';
const PHOTO_REMOVE_IMAGES = ROOT_API + 'load_file/photo_remove_images.php';

export default {
	state: {
		photoList: []
	},

	mutations: {
		pushPhotoList(state, photo) { state.photoList.push(photo); },

		clearPhotoList(state) { state.photoList = []; }
	},

	actions: {
		/* PHOTO */
		async getPhotoList(context, lpo_id) {
			const { commit, dispatch } = context;

			const photoFileList = await dispatch('_getPhotoFileList', lpo_id);

			console.log(photoFileList);

			commit('clearPhotoList');

			for (let file of photoFileList) {
				dispatch('_getPhotoImage', file);
			}
		},

		_getPhotoFileList(context, lpo_id) {
			const form = new FormData();
			form.append('lpo_id', lpo_id);

			return fetch(PHOTO_GET_PATH_LIST, {
				credentials: 'include',
				method: 'post',
				body: form
			})
			.then(res => res.json());
		},

		_getPhotoImage(context, file) {
			const { commit } = context;

			const form = new FormData();
			form.append('path', file.path);

			fetch(PHOTO_GET_IMAGE, {
				credentials: 'include',
				method: 'post',
				body: form
			})
			.then(res => res.blob())
			.then(res => {
				const url = URL.createObjectURL(res);

				const temp = {
					name: file.name,
					path: file.path,
					url: url,
					checked: false
				};

				commit('pushPhotoList', temp);
			});
		}

	}
};